import {
  ContentTable,
  CustomTableLayout,
  StyleDictionary,
  TableCell,
} from "pdfmake/interfaces";
import { TableLayouts } from "zna-lib";

const sammelmeldungStyles: StyleDictionary = {
  h1: {
    bold: true,
    fontSize: 13.5,
    color: "black",
  },
  h1u: {
    bold: true,
    decoration: "underline",
    fontSize: 13.5,
    color: "black",
    // fillColor: "#ddd",
  },
  h2: {
    fontSize: 11,
    color: "black",
  },
  tableText: {
    margin: [8, -2, 0, -3],
  },
  tableText2: {
    fontSize: 11,
    margin: [0, 0, 0, 0],
  },
  tableText3: {
    fontSize: 9,
    margin: [0, 0, 0, 0],
  },
  tableTextBold: {
    fontSize: 11,
    bold: true,
  },
  small: {
    fontSize: 8,
    bold: false,
    margin: [8, -2, 0, 3],
  },
  smaller: {
    fontSize: 7.5,
    bold: false,
    margin: [0, 0, 0, 0],
  },
};

const monatsblattStyles: StyleDictionary = {
  header: {
    fontSize: 16,
    bold: true,
    margin: [0, 0, 0, 10],
  },
  subheader: {
    fontSize: 14,
    bold: true,
    margin: [0, 10, 0, 5],
  },
  tableExample: {
    margin: [0, 0, 0, 0],
  },
  tableHeader: {
    bold: true,
    fontSize: 11,
    color: "black",
  },
  tableSummeHeader: {
    bold: true,
    fontSize: 11,
    color: "black",
    fillColor: "#ddd",
  },
  tableLogo: {
    margin: 20,
    bold: true,
    fontSize: 13,
    color: "black",
  },
  fett: {
    fontSize: 11,
    bold: true,
  },
  small: {
    fontSize: 8,
  },
};

const kassenbuchStyles: StyleDictionary = {
  h1: {
    bold: true,
    fontSize: 13.5,
    color: "black",
  },
  h1u: {
    bold: true,
    decoration: "underline",
    fontSize: 13.5,
    color: "black",
    // fillColor: "#ddd",
  },
  h2: {
    fontSize: 11,
    color: "black",
  },
  tableText: {
    margin: [8, -2, 0, -3],
  },
  tableText2: {
    fontSize: 11,
    margin: [0, 0, 0, 0],
  },
  tableText3: {
    fontSize: 9,
    margin: [0, 0, 0, 0],
  },
  tableTextBold: {
    fontSize: 11,
    bold: true,
  },
  small: {
    fontSize: 8,
    bold: false,
    margin: [8, -2, 0, 3],
  },
  smaller: {
    fontSize: 7.5,
    bold: false,
    margin: [0, 0, 0, 0],
  },
};

const calculateMarginsForCoverTable = function(ri: number, node: any): number {
  const cellHeights: number[] = node.table.body[ri].map((cell: any) => {
    if (cell._inlines && cell._inlines.length) {
      return cell._inlines[0].height;
    } else if (cell.stack) {
      return cell.stack[0]._inlines[0].height * cell.stack.length;
    }
    return null;
  });

  node.table.body[ri].forEach((cell: any, ci: number) => {
    if (cellHeights[ci]) {
      let topMargin = cellHeights[ci];
      if (ri == 0) {
        topMargin -= 5;
      } else if (ri == 3 && (ci == 2 || ci == 4)) {
        topMargin += 11;
      } else if (ri == 4) {
        topMargin += 15;
      } else if (ri == 5) {
        topMargin += 26;
      } else {
        topMargin -= 3;
      }

      if (cell._margin) {
        cell._margin[1] = topMargin;
      } else {
        cell._margin = [0, topMargin, 0, 0];
      }
    }
  });

  return 0;
};

const solidHorizontalLines: CustomTableLayout = {
  hLineWidth(rowIndex: number, node: ContentTable, columnIndex: number) {
    return rowIndex % 2 == 1 ? 0.5 : 0;
    /*
        if (rowIndex === 0 || rowIndex === node.table.body.length) {
          return 0;
        }
        return rowIndex === node.table.headerRows ? 2 : 1;
        */
  },
  vLineWidth(rowIndex: number, node: ContentTable, columnIndex: number) {
    return 0;
  },
  hLineColor(rowIndex: number, node: ContentTable, columnIndex: number) {
    return "black";
  },
  paddingLeft(rowIndex: number, node: ContentTable, columnIndex: number) {
    return 0;
  },
  paddingRight(rowIndex: number, node: ContentTable, columnIndex: number) {
    return 0; //rowIndex === (node.table?.widths as Size[]).length - 1 ? 0 : 8;
  },
};
const monatsblattKopfdaten: CustomTableLayout = Object.assign(
  {},
  solidHorizontalLines,
  {
    hLineWidth(rowIndex: number, node: ContentTable, columnIndex: number) {
      return rowIndex <= 3 ? 0.5 : 1;
    },
    hLineStyle: function(rowIndex: number, node: ContentTable) {
      return { dash: { length: 1, space: 2 } };
    },
    paddingTop(rowIndex: number, node: ContentTable, columnIndex: number) {
      if (rowIndex % 2 === 0) {
        switch (rowIndex) {
          case 0:
            return 38;
          case 14:
            return 0;
          case 8:
            return -2;
          case 10:
          case 12:
            return -1;
          default:
            return -4;
        }
      } else {
        return 8;
      }
    },
    paddingBottom(rowIndex: number, node: ContentTable, columnIndex: number) {
      return rowIndex % 2 === 0 ? 8 : -2;
    },
    paddingLeft(rowIndex: number, node: ContentTable, columnIndex: number) {
      return 0;
    },
  } as CustomTableLayout
);
const monatsblattOptionen: CustomTableLayout = Object.assign(
  {},
  monatsblattKopfdaten,
  {
    paddingTop(rowIndex: number, node: ContentTable, columnIndex: number) {
      switch (rowIndex) {
        case 0:
          return -5;
        case 2:
          return 12;
        default:
          return 11;
      }
    },
    paddingBottom(rowIndex: number, node: ContentTable, columnIndex: number) {
      return -2;
    },
  } as CustomTableLayout
);
const dottedBorders: CustomTableLayout = Object.assign(
  {},
  monatsblattKopfdaten,
  {
    paddingTop: calculateMarginsForCoverTable,
    paddingBottom(rowIndex: number, node: ContentTable, columnIndex: number) {
      return -2;
    },
  } as CustomTableLayout
);
const signatures: CustomTableLayout = Object.assign({}, dottedBorders, {
  hLineWidth(rowIndex: number, node: ContentTable, columnIndex: number) {
    return 0.5;
  },
  paddingTop(rowIndex: number, node: ContentTable, columnIndex: number) {
    return rowIndex === 1 ? 2 : 0;
  },
  paddingBottom(rowIndex: number, node: ContentTable, columnIndex: number) {
    return rowIndex === 0 ? -2 : 0;
  },
} as CustomTableLayout);
const solidLines: CustomTableLayout = Object.assign({}, solidHorizontalLines, {
  hLineWidth(rowIndex: number, node: ContentTable, columnIndex: number) {
    return 0.5;
  },
  vLineWidth(rowIndex: number, node: ContentTable, columnIndex: number) {
    return 0.5;
  },
  paddingTop(rowIndex: number, node: ContentTable, columnIndex: number) {
    return 0;
  },
  paddingBottom(rowIndex: number, node: ContentTable, columnIndex: number) {
    return 0;
  },
  paddingLeft(rowIndex: number, node: ContentTable, columnIndex: number) {
    return 0;
  },
  paddingRight(rowIndex: number, node: ContentTable, columnIndex: number) {
    return 0;
  },
} as CustomTableLayout);
const rechnung: CustomTableLayout = Object.assign({}, solidLines, {
  defaultBorder: false,
  hLineWidth(rowIndex: number, node: ContentTable, columnIndex: number) {
    if (rowIndex == 14) {
      return 2;
    } else {
      return 0;
    }
  },
  vLineWidth(rowIndex: number, node: ContentTable, columnIndex: number) {
    return 0;
  },
  paddingTop(rowIndex: number, node: ContentTable, columnIndex: number) {
    if (rowIndex >= 7 && rowIndex < 10) { // Name - Steuernummer der Dame
      return 15;
    }
    switch(rowIndex) {
      case 10: return 50; // Rechnung Nr
      case 11: return 40; // Zimmernutzung
      case 14: return 20;
      case 15: return 40;
      case 16: return 25;
      case 17: return 15;
      default: return 7;
    }
  },
  paddingLeft(rowIndex: number, node: ContentTable, columnIndex: number) {return 2;},
  paddingRight(rowIndex: number, node: ContentTable, columnIndex: number) {return 2;},
} as CustomTableLayout);
const quittung: CustomTableLayout = Object.assign({}, rechnung, {
  hLineWidth(rowIndex: number, node: ContentTable, columnIndex: number) {
    return 0;
  },
  paddingTop(rowIndex: number, node: ContentTable, columnIndex: number) {
    if (rowIndex >= 7 && rowIndex < 10) { // Name - Steuernummer der Dame
      return 15;
    }
    switch(rowIndex) {
      case 10: return 50; // Quittung
      case 11: return 40; // Düdorfer Verfahren
      case 12: return 20;
      case 13: return 40;
      case 14: return 25;
      case 15: return 15;
      default: return 7;
    }
  },
} as CustomTableLayout);

const tableLayouts: TableLayouts = {
  solidHorizontalLines,
  dottedBorders,
  monatsblattKopfdaten,
  monatsblattOptionen,
  signatures,
  solidLines,
  rechnung,
  quittung,
};

const borderBottom = [false, false, false, true];
const noBorder = [false, false, false, false];

const getOption = (checked: boolean): TableCell => {
  return {
    image: checked ? "optionsfeldAngekreuzt" : "optionsfeld",
    /*
  let svgCode =
    '<svg width="65" height="65" xmlns="http://www.w3.org/2000/svg">' +
    "<!-- Created with Method Draw - http://github.com/duopixel/Method-Draw/ -->" +
    "<g>" +
    "<title>Optionsfeld</title>" +
    '<ellipse fill="#fff" stroke-width="1.5" cx="32.25" cy="32.25" id="svg_1" rx="30" ry="30" stroke="#000"/>';
  if (checked) {
    svgCode +=
      '<line fill="none" stroke-width="1.5" stroke-opacity="null" fill-opacity="null" x1="11.75" y1="52.74998" x2="52.29252" y2="12.20746" id="svg_2" stroke-linejoin="null" stroke-linecap="null" stroke="#000"/>' +
      '<line fill="none" stroke-width="1.5" stroke-opacity="null" fill-opacity="null" x1="52.41666" y1="52.74998" x2="12.06126" y2="12.39457" id="svg_3" stroke-linejoin="null" stroke-linecap="null" stroke="#000"/>';
  }
  svgCode += "</g></svg>";
  return {
    svg: svgCode,
    options: {
      assumePt: false,
    },
    /*
    height: 15,
    fit: [15, 15],
    */
    width: 15,
    border: noBorder,
    margin: [7, 0, 0, 0],
  };
};

export { sammelmeldungStyles, monatsblattStyles, kassenbuchStyles, tableLayouts, rechnung, borderBottom, noBorder, getOption };
